import React from "react";
import { Link, useParams } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import LearnHutLogo from "../Logos To be used/learnhut_logo_recolored.png";
import "./SubjectClosed.css";

const CLOSED_SUBJECT_IDS = new Set([
  "385999b9-532a-4526-8ba4-40c86f47a0f2",
  "94ce3248-7a00-40be-b5f6-8c4f831ad526",
  "d2c5857d-4d6c-4e1d-aaa5-a6a0875cac40",
]);

const SUBJECT_CLOSED_QUERY = gql`
  query SubjectClosed($id: ID!) {
    subject(id: $id) {
      id
      title
      imageUrl
    }
  }
`;

const workItems = [
  "Überarbeitung und Korrektur einzelner Lektionen",
  "Behebung technischer Probleme aus der Testphase",
  "Stabilere Darstellung von Formeln und mathematischen Inhalten",
  "KI-generierte Übungsaufgaben mit Lösungen",
  "KI-generierte Quizfragen",
  "KI-generierte Klausurbeispiele zur Prüfungsvorbereitung",
  "Vorbereitung einer englischen Version",
];

const completedItems = new Set([
  "KI-generierte Übungsaufgaben mit Lösungen",
  "KI-generierte Quizfragen",
  "KI-generierte Klausurbeispiele zur Prüfungsvorbereitung",
]);

function SubjectClosed() {
  const { subjectId } = useParams();
  const role = localStorage.getItem("userRole");
  const dashboardPath = role === "TUTOR" || role === "ADMIN" ? "/dashboard-tutor" : "/dashboard";
  const isKnownClosedSubject = CLOSED_SUBJECT_IDS.has(subjectId || "");

  const { data } = useQuery(SUBJECT_CLOSED_QUERY, {
    variables: { id: subjectId },
    skip: !subjectId,
    fetchPolicy: "cache-first",
  });

  const subject = data?.subject;
  const subjectTitle = subject?.title || "Dieses Fach";

  return (
    <main className="subject-closed-page">
      <section className="subject-closed-hero">
        <div className="subject-closed-brand">
          <img src={LearnHutLogo} alt="LearnHut" />
          <span>Testphase abgeschlossen</span>
        </div>

        <div className="subject-closed-hero-grid">
          <div className="subject-closed-copy">
            <span className="subject-closed-badge">Vorübergehend geschlossen</span>
            <h1>{subjectTitle} wird gerade überarbeitet.</h1>
            <p>
              Vielen Dank, dass ihr LearnHut in der Testphase genutzt und uns so
              viele hilfreiche Rückmeldungen gegeben habt. Wir haben inzwischen
              genügend Feedback gesammelt und nutzen die kommenden Wochen, um die
              Plattform gezielt weiterzuentwickeln.
            </p>
            <p>
              Einige technische Probleme, unklare Stellen in Lektionen und die
              Darstellung mathematischer Formeln werden jetzt systematisch
              verbessert. Die Plattform kommt zum nächsten Semester stabiler,
              verständlicher und mit weiteren Funktionen zurück.
            </p>

            <div className="subject-closed-actions">
              <Link to={dashboardPath}>Zurück zum Dashboard</Link>
            </div>
          </div>

          <aside className="subject-closed-status-card" aria-label="Status">
            <span>Status</span>
            <strong>Geschlossen bis zum nächsten Semester</strong>
            <p>
              {isKnownClosedSubject
                ? "Dieses Fach gehört zur aktuellen Pause der Testphase."
                : "Diese Seite informiert über die aktuelle LearnHut-Pause."}
            </p>
          </aside>
        </div>
      </section>

      <section className="subject-closed-section" aria-labelledby="subject-closed-work-title">
        <div className="subject-closed-section-head">
          <span>Woran wir arbeiten</span>
          <h2 id="subject-closed-work-title">Feedback wird in konkrete Verbesserungen umgesetzt.</h2>
        </div>

        <div className="subject-closed-work-grid">
          {workItems.map((item) => {
            const isCompleted = completedItems.has(item);
            return (
              <article className="subject-closed-work-card" key={item}>
                <span className={isCompleted ? "is-completed" : ""} aria-hidden="true" />
                <p>{item}</p>
                {isCompleted ? <strong>erledigt</strong> : null}
              </article>
            );
          })}
        </div>
      </section>

      <section className="subject-closed-note">
        <h2>Weitere Rückmeldungen sind willkommen.</h2>
        <p>
          Falls euch noch Fehler aufgefallen sind oder ihr euch bestimmte Funktionen
          für LearnHut wünscht, könnt ihr uns weiterhin gerne per E-Mail schreiben.
        </p>
        <p>Danke für eure Zeit, eure ehrlichen Hinweise und eure Unterstützung.</p>
      </section>
    </main>
  );
}

export default SubjectClosed;
